function mapBoundaryUrl(communityName, isFullBoundary = false) {
  return `https://ingenuity-artlook.s3.us-east-2.amazonaws.com/communityConfigs/${communityName}/${
    isFullBoundary ? 'full_boundary' : 'boundaries'
  }.json`
}

export default mapBoundaryUrl
